const gallerySlider = () => {
  const wpBlockGalleries = document.querySelectorAll('.wp-block-gallery'),
        bodyWrap = document.querySelector('#body-wrap');
  var stageCreated = false,
      sliderImage,
      sliderStage,
      sliderCaption,
      sliderNavWrap,
      sliderNext,
      sliderPrev,
      sliderClose,
      currentGallery,
      currentSlide;
  function createSliderStage(gallery) {
    currentGallery = gallery;
    sliderStage = document.createElement('div');
    sliderImage = document.createElement('div');
    sliderCaption = document.createElement('div');
    sliderNavWrap = document.createElement('div');
    sliderNext = document.createElement('button');
    sliderPrev = document.createElement('button');
    sliderClose = document.createElement('button');
    sliderStage.setAttribute('id', 'p13-slider-stage');
    sliderImage.setAttribute('id', 'p13-slider-image');
    sliderCaption.setAttribute('id', 'p13-slider-caption');
    sliderNavWrap.setAttribute('id', 'p13-slider-nav');
    sliderNext.setAttribute('id', 'p13-slider-next');
    sliderPrev.setAttribute('id', 'p13-slider-prev');
    sliderClose.setAttribute('id', 'p13-slider-close');
    sliderClose.textContent = 'close modal slider';
    sliderPrev.textContent = 'previous slide';
    sliderNext.textContent = 'next slide';
    sliderStage.append(sliderClose);
    sliderStage.append(sliderImage);
    sliderImage.append(sliderCaption);
    sliderStage.append(sliderNavWrap);
    sliderNavWrap.append(sliderPrev);
    sliderNavWrap.append(sliderNext);
    sliderCaption.addEventListener('click', function(e) {
      e.stopPropagation();
    });
    sliderNext.addEventListener('click', function(e) {
      e.stopPropagation();
      changeSlide('next');
    });
    sliderPrev.addEventListener('click', function(e) {
      e.stopPropagation();
      changeSlide('prev');
    });
    document.querySelector('body').append(sliderStage);
    stageCreated = true;
    sliderStage.addEventListener('click', function() {
      sliderStage.remove();
      stageCreated = false;
    })
    sliderImage.addEventListener('click', function(e) {
      e.stopPropagation();
    })
  }

  function changeSlide(dir) {
    if(dir == 'next') {
      if(currentSlide == currentGallery.dataset.total) {
        getSlide(currentGallery.querySelector('[data-slide="1"]'));
      } else {
        getSlide(currentGallery.querySelector('[data-slide="'+(parseInt(currentSlide)+1)+'"]'));
      }
    }
    if(dir == 'prev') {
      if(currentSlide == 1) {
        getSlide(currentGallery.querySelector('[data-slide="'+(currentGallery.dataset.total)+'"]'));
      } else {
        getSlide(currentGallery.querySelector('[data-slide="'+(parseInt(currentSlide)-1)+'"]'));
      }
    }
  }

  function getSlide(slide) {
    currentSlide = slide.dataset.slide;
    sliderImage.style.opacity = 0;
    setTimeout(() => {
      sliderStage.classList.remove('is-tall');
      sliderImage.innerHTML = '';
      sliderCaption.innerHTML = '';
      if(!slide.hasAttribute('data-img_src')) { // if image hasn't been loaded yet
        sliderStage.classList.add('loading');
        var imgId = slide.querySelector('img').getAttribute('class'),
            imgSize = isMobile ? 'medium_large' : 'full_width';
        fetch(document.querySelector('#body-wrap').dataset.themeUri+'/theme-functions/ajax/gallery-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            slide: imgId,
            size: imgSize
          }),
        })
        .then(function (result) {
          return result.json();
        })
        .then(function (data) {
          if (data.length > 0) {
            var slideImage = new Image(),
                slideCaption = slide.parentElement.querySelector('figcaption'),
                captionHeight = 0;
            slideImage.src = data[0];
            slideImage.onload = function () {
              slide.setAttribute('data-img_src', data[0]);
              slideImage.classList.add('slider-image');
              slideImage.setAttribute('width', data[1]);
              slideImage.setAttribute('height', data[2]);
              slide.setAttribute('data-width', data[1]);
              slide.setAttribute('data-height', data[2]);
              if(slideCaption != null) { 
                slideImage.setAttribute('alt', slideCaption.textContent);
              } else {
                slideImage.setAttribute('alt', '');
              }
              sliderImage.style.width = 'auto';
              sliderImage.append(slideImage);
              setTimeout(() => {
                sliderStage.classList.remove('loading');
                if(slideCaption) {
                  sliderCaption.innerHTML = slideCaption.innerHTML;
                  slideCaption.style.width = slideImage.clientWidth+'px';
                  sliderImage.append(sliderCaption);
                  captionHeight = sliderCaption.clientHeight;
                }
                setTimeout(() => {
                  sliderImage.style.opacity = 1;
                  if(slideImage.clientHeight > (window.innerHeight-130-captionHeight)) {
                    sliderStage.classList.add('is-tall');
                  }
                }, 10);
              }, 50);
            }
          }
        });
      } else {
        var slideImage = document.createElement('img'),
            slideCaption = slide.parentElement.querySelector('figcaption'),
            captionHeight = 0;
        //sliderStage.classList.add('loading');
        slideImage.setAttribute('src', slide.dataset.img_src);
        slideImage.classList.add('slider-image');
        slideImage.setAttribute('width', slide.dataset.width);
        slideImage.setAttribute('height', slide.dataset.height);
        if(slideCaption != null) { 
          slideImage.setAttribute('alt', slideCaption.textContent);
        } else {
          slideImage.setAttribute('alt', '');
        }
        sliderImage.style.width = 'auto';
        sliderImage.append(slideImage);
        
        if(slideCaption) {
          sliderCaption.innerHTML = slideCaption.innerHTML;
          sliderImage.append(sliderCaption);
          captionHeight = sliderCaption.clientHeight;
        }
        setTimeout(() => {
          sliderImage.style.opacity = 1;
          sliderStage.classList.remove('loading');
          if(slideImage.clientHeight > (window.innerHeight-130-captionHeight)) {
            sliderStage.classList.add('is-tall');
          }
        }, 10);
        

      }
    }, 500)
  }

  if(wpBlockGalleries) {
    wpBlockGalleries.forEach(function(gallery) {
      const slides = gallery.querySelectorAll('.wp-block-image > a');
      if(slides) {
        var i = 0;
        slides.forEach(function(slide) {
          i++;
          slide.classList.add('slide-'+i);
          slide.setAttribute('data-slide', i);
          slide.addEventListener('click', function(e) {
            e.preventDefault();
            if(!stageCreated) {
              createSliderStage(gallery);
            }
            currentSlide = slide.dataset.slide;
            getSlide(slide);
          })
        })
        gallery.setAttribute('data-total', i);
      }
    })
  }

  var isMobile = window.innerWidth < 993 ? true : false;

  function getTouches(evt) {
    return evt.touches ||             // browser API
      evt.originalEvent.touches; // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }
    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;
    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        /* right swipe */
        if(evt.target.classList.contains('slider-image') || evt.target.getAttribute('id') == 'p13-slider-caption' || evt.target.getAttribute('id') == 'p13-slider-stage') {
          changeSlide('next');
        }
      } else {
        /* left swipe */
        if(evt.target.classList.contains('slider-image') || evt.target.getAttribute('id') == 'p13-slider-caption' || evt.target.getAttribute('id') == 'p13-slider-stage') {
          changeSlide('prev');
        }
      }
    }
    xDown = null;
    yDown = null;
  }

  if(isMobile) {
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
    var xDown = null;
    var yDown = null;
  }
}

export default gallerySlider;